<template>
    <div class="v-for-component">
        <ul class="foods">
            <p>食べ物のリスト</p>
            <li v-for="food in foods" :key="food.name">
                名前：{{food.name}} 色：{{food.color}}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    data(){
        return{
            foods: [
                {name: "banana",color:"yellow"},
                {name: "apple",color:"red"},
                {name: "peach",color:"pink"},
            ],

        }
    }
}
</script>

<style scoped>

</style>